export default __webpack_public_path__ + "static/media/15.090704ee.jpg";